/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_CatalogInputs */

const en_nav_section_catalog = /** @type {(inputs: Nav_Section_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog`)
};

/**
* | output |
* | --- |
* | "Catalog" |
*
* @param {Nav_Section_CatalogInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_catalog = /** @type {((inputs?: Nav_Section_CatalogInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_CatalogInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_catalog(inputs)
});